<template>
  <div class="delivery-form">
    <el-form size="small" :model="form" ref="deliveryForm" :rules="rules" label-position="top" :disabled="operateType == 'show'" v-loading="submitLoading">
      <div class="form-block">
        <h4 class="title">投放信息</h4>
        <el-divider class="divider"></el-divider>
        <div class="block-main">
          <el-form-item label="账号平台" prop="mediaType" class="block-form-item w-25">
            <el-select v-model="form.mediaType" size="small" placeholder="未选择" class="w-100" @change="onChangeMediaType" :disabled="operateType != 'add'">
              <el-option v-for="(label, value) in mediaConfig.getConfigList('media_ch')" :key="value" :label="label" :value="parseInt(value)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="博主名称" prop="bloggerName" class="block-form-item w-25 select-input-wrap-s">
            <el-input :value="form.bloggerName && form.bloggerName" disabled>
              <i v-if="operateType == 'add'" slot="append" class="iconfont icon-xialaxuanze_xialaduoxuan" @click="onOpenMediaSelectModal"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="关联合同" prop="contractId" class="block-form-item w-25 select-input-wrap-s">
            <el-input :value="form.contractName && form.contractName" disabled>
              <i slot="append" v-if="$route.query.type != 'show'" class="iconfont icon-xialaxuanze_xialaduoxuan" @click="contractClick"></i>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="关联合同" prop="contractId" class="block-form-item w-25">
            <el-select :disabled="operateType != 'add'" v-model="form.contractId" size="small" placeholder="未选择" class="w-100" @change="selectContract">
              <el-option v-for="(item, index) in relateContractList" :key="index" :label="item.name" :value="item.id" :disabled="item.disabled"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="客户名称" prop="customerName" class="block-form-item w-25">
            <el-input v-model="form.customerName" disabled></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName" class="block-form-item w-25">
            <el-input v-model="form.productName"></el-input>
          </el-form-item>
          <el-form-item label="品牌名称" prop="brandName" class="block-form-item w-25">
            <el-input v-model="form.brandName"></el-input>
          </el-form-item>
          <el-form-item label="发布形式" prop="publishType" class="block-form-item w-25">
            <el-input v-model="form.publishType"></el-input>
          </el-form-item>
          <el-form-item label="发布日期" prop="publishTime" class="block-form-item w-25">
            <el-date-picker v-model="form.publishTime" type="date" value-format="yyyy-MM-dd 00:00:00" class="w-100">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="执行价" prop="executePrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center" slot="label">
              执行价
              <el-tooltip class="item" effect="light" content="单个博主合作总价" placement="top">
                <i class="iconfont icon-tishi" style="color: #303133; margin-left: 10px; font-size: 12px"></i>
              </el-tooltip>
            </div>
            <el-input v-model="form.executePrice"></el-input>
          </el-form-item>
          <el-form-item label="投放链接" prop="publishUrl" class="block-form-item w-25">
            <el-input v-model="form.publishUrl"></el-input>
          </el-form-item>
          <el-form-item label="外部平台" prop="externalPlatform" class="block-form-item w-25">
            <el-input maxlength="50" v-model="form.externalPlatform"></el-input>
          </el-form-item>
          <el-form-item label="外部平台任务ID" prop="externalPlatformTaskId" class="block-form-item w-25">
            <el-input maxlength="50" v-model="form.externalPlatformTaskId"></el-input>
          </el-form-item>
          <el-form-item label="平台公司" prop="platfromCompanyId" class="block-form-item w-25">
            <el-select v-model="form.platfromCompanyId" class="w-100" >
              <el-option 
                v-for="(a, index) in platfromCompanyId" 
                :key="index" 
                :label="a.name" 
                :value="a.id"
                :disabled="!a.isEnable"
                >
                <div style="display: flex;padding:0 10px;justify-content: space-between;">
                  <div>{{a.name}}</div>
                  <div style="margin-left:15px;">{{a.isEnable?'':'已禁用'}}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="投放负责人" prop="recordPrincipal" class="block-form-item w-25 select-input-wrap-s">
            <el-input :value="form.recordPrincipal && form.recordPrincipal" disabled>
              <i v-if="operateType == 'add'||operateType == 'edit'" slot="append" class="iconfont icon-xialaxuanze_xialaduoxuan" @click="onOpenAdminSelectModal"></i>
            </el-input>
          </el-form-item>
        </div>
        <div class="bottom-divider"></div>
      </div>

      <div class="form-block">
        <h4 class="title">结算信息</h4>
        <el-divider class="divider"></el-divider>
        <div class="block-main">
          <el-form-item label="结算状态" prop="settleStatus" class="block-form-item w-25">
            <el-select v-model="form.settleStatus" size="small" placeholder="未选择" class="w-100">
              <el-option v-for="(label, value) in deliveryConfig.getConfigList('settle_status')" :key="value" :label="label" :value="parseInt(value)"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算金额" prop="settlePrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center" slot="label">
              结算金额
              <el-tooltip class="item" effect="light" content="实际付给博主的钱" placement="top">
                <i class="iconfont icon-tishi" style="color: #303133; margin-left: 10px; font-size: 12px"></i>
              </el-tooltip>
            </div>
            <el-input v-model="form.settlePrice"></el-input>
          </el-form-item>
          <el-form-item label="结算日期" prop="settleTime" class="block-form-item w-25">
            <el-date-picker v-model="form.settleTime" type="date" value-format="yyyy-MM-dd 00:00:00" class="w-100">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="收款方" prop="receiptPart" class="block-form-item w-25">
            <el-input v-model="form.receiptPart"></el-input>
          </el-form-item>
          <el-form-item label="收款日期" prop="receiptTime" class="block-form-item w-25">
            <el-date-picker v-model="form.receiptTime" type="date" value-format="yyyy-MM-dd 00:00:00" class="w-100">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="分成基数金额" prop="shareIncome" class="block-form-item w-25">
            <el-input v-model="form.shareIncome"></el-input>
          </el-form-item>
          <el-form-item label="固定返点" prop="fixedRebate" class="block-form-item w-25">
            <el-input maxlength="50" v-model="form.fixedRebate"></el-input>
          </el-form-item>
          <el-form-item prop="finalRebate" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center" slot="label">
              最终返点
              <el-tooltip class="item" effect="light" content="根据最终返点生成返点记录" placement="top">
                <i class="iconfont icon-tishi" style="color: #303133; margin-left: 10px; font-size: 12px"></i>
              </el-tooltip>
            </div>
            <el-input type="number" :disabled="form.isRebateConfirmed" @input="rebatesInput" v-model="form.finalRebate"></el-input>
          </el-form-item>
        </div>
        <div class="bottom-divider"></div>
      </div>
      <div class="form-block">
        <h4 class="title">博主其他成本</h4>
        <el-divider class="divider"></el-divider>
        <el-form :model="bloggerForm" ref="bloggerForm" size="small" :disabled="operateType == 'show'">
          <el-form-item label="博主其它总成本" prop="bloggerOtherCost" class="block-form-item w-25">
            <el-input v-model="form.bloggerOtherCost" disabled></el-input>
          </el-form-item>
          <el-table :data="bloggerForm.bloggerOtherCostList" border size="small">
            <!-- 成本金额 -->
            <el-table-column prop="costMoney" label="成本金额" align="center" width="230">
              <template slot-scope="scope">
                <el-form-item :prop="'bloggerOtherCostList[' + scope.$index + '].costMoney'" label-width="0" :rules="bloggerRules.costMoney">
                  <el-input v-model="scope.row.costMoney" placeholder="请输入成本金额"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- 项目 -->
            <el-table-column prop="project" label="项目" align="center">

              <template slot-scope="scope">
                <el-form-item :prop="'bloggerOtherCostList[' + scope.$index + '].project'" label-width="0" :rules="bloggerRules.project">
                  <el-input v-model="scope.row.project" placeholder="请输入成本金额明细"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column fixed="right" label="操作" width="100" align="center">
              <template slot="header" slot-scope="scope">
                <el-button type="primary" size="mini" class="btn--red" @click="addBlogger" v-if="operateType != 'show'">+ 新增</el-button>
              </template>
              <template slot-scope="scope">
                <el-button v-if="operateType != 'show'&&(bloggerForm.bloggerOtherCostList.length > 1 && bloggerForm.bloggerOtherCostList.length > 1)" type="text" class="color_red" icon="el-icon-remove-outline"
                  style="font-size: 32px; margin-bottom: 20px; cursor: pointer;" circle @click="removeBlogger(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="bottom-divider" v-if="operateType !== 'show'"></div>
      </div>

      <div class="form-block">
        <h4 class="title">其他成本</h4>
        <el-divider class="divider"></el-divider>
        <el-form size="small" :disabled="operateType == 'show'">
          <el-form-item label="其它总成本" prop="otherCost" class="block-form-item w-25">
            <el-input v-model="form.otherCost" disabled></el-input>
          </el-form-item>
        </el-form>
        <el-form size="small" :disabled="operateType == 'show'">
          <el-form-item label="微任务" prop="wxjobPrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              微任务(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="form.wxjobPrice"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="预设返点" prop="presetRebatePrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              预设返点(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="form.presetRebatePrice"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="代下单费用" prop="agentOrderPrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              代下单费用(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="form.agentOrderPrice"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="其他成本" prop="otherPrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              其他成本(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="form.otherPrice"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="差旅费用" prop="travelPrice" class="block-form-item w-25">
            <div style="display: flex; align-items: center; justify-content: center;" slot="label">
              差旅费用(元)
            </div>
            <div style="display: flex; align-items: center; justify-content: center;">
              <el-input v-model="form.travelPrice"></el-input>
            </div>
          </el-form-item>
          
        </el-form>
        <div class="bottom-divider" v-if="operateType !== 'show'"></div>
      </div>

      <div class="form-block">
        <h4 class="title">博主/供应商发票信息</h4>
        <el-divider class="divider"></el-divider>
        <el-form :model="invoiceForm" ref="invoiceForm" size="small" :disabled="operateType == 'show'">
          <el-form-item label="发票总金额" prop="totalInvoiceMoney" class="block-form-item w-25">
            <el-input v-model="invoiceForm.totalInvoiceMoney" disabled></el-input>
          </el-form-item>
          <el-table :data="invoiceForm.bloggerInvoiceList" border size="small">
            <!-- 发票金额 -->
            <el-table-column prop="invoiceMoney" label="发票金额" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'bloggerInvoiceList[' + scope.$index + '].invoiceMoney'" label-width="0" :rules="invoiceRules.invoiceMoney">
                  <el-input v-model="scope.row.invoiceMoney" placeholder="请输入发票金额"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- 发票抬头 -->
            <el-table-column prop="invoiceTitle" label="发票抬头" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'bloggerInvoiceList[' + scope.$index + '].invoiceTitle'" label-width="0" :rules="invoiceRules.invoiceTitle">
                  <el-input v-model="scope.row.invoiceTitle" placeholder="请输入发票抬头"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- 发票号 -->
            <el-table-column prop="invoiceNum" label="发票号" align="center">

              <template slot-scope="scope">
                <el-form-item :prop="'bloggerInvoiceList[' + scope.$index + '].invoiceNum'" label-width="0" :rules="invoiceRules.invoiceNum">
                  <el-input v-model="scope.row.invoiceNum" placeholder="请输入发票号"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- 发票时间 -->
            <el-table-column prop="invoiceTime" label="发票时间" align="center">

              <template slot-scope="scope">
                <el-form-item :prop="'bloggerInvoiceList[' + scope.$index + '].invoiceTime'" label-width="0" :rules="invoiceRules.invoiceTime">
                  <el-date-picker v-model="scope.row.invoiceTime" type="date" value-format="yyyy-MM-dd 00:00:00" placeholder="请输入发票时间">
                  </el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- 发票类型 -->
            <el-table-column prop="invoiceType" label="发票类型" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'bloggerInvoiceList[' + scope.$index + '].invoiceType'" label-width="0" :rules="invoiceRules.invoiceType">
                  <el-select v-model="scope.row.invoiceType" placeholder="请选择发票类型" clearable>
                    <el-option
                      v-for="(item, index) in billingConfig.getConfigList('invoiceType')"
                      :label="item.name"
                      :value="parseInt(item.id)"
                      :key="index"
                      :disabled="!item.isEnable" 
                    >
                      <div style="display: flex;padding:0 10px;justify-content: space-between;">
                        <div>{{item.name}}</div>
                        <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>

              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column fixed="right" label="操作" width="100" align="center">
              <template slot="header" slot-scope="scope">
                <el-button type="primary" size="mini" class="btn--red" @click="addInvoice" v-if="operateType != 'show'">+ 新增</el-button>
              </template>
              <template slot-scope="scope">
                <el-button v-if="operateType != 'show'&&(invoiceForm.bloggerInvoiceList.length > 1 && invoiceForm.bloggerInvoiceList.length > 1)" type="text" class="color_red" icon="el-icon-remove-outline"
                  style="font-size: 32px; margin-bottom: 20px; cursor: pointer;" circle @click="removeInvoice(scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="bottom-divider" v-if="operateType !== 'show'"></div>
      </div>
      <div class="form-block-submit" v-if="operateType !== 'show'">
        <el-button type="primary" size="small" @click="onSubmit" :disabled="submitLoading">提交</el-button>
      </div>
    </el-form>

    <el-dialog title="添加博主" :visible.sync="mediaListModal" width="1000px" class="yhg-dialog" @open="openMediaSelectModal">
      <div class="select-con single">
        <span class="label">已选账号：</span>
        <div class="content" v-if="selectMedia">
          <el-tag class="select-tag" closable :type="selectMedia.name" effect="dark" @close="onMediaTagClose">
            <span class="select-tag-text">{{ selectMedia.name }}</span>
          </el-tag>
        </div>
      </div>
      <div class="filter-con">
        <span class="label">账号搜索：</span>
        <el-input size="small" v-model="mediaForm.queryString" placeholder="账号名称/ID/链接" @keyup.enter.native="onMediaSearch"></el-input>
        <el-button class="search-btn" size="small" type="primary" @click="onMediaSearch">搜索</el-button>
      </div>
      <div class="table-con">
        <el-table :data="mediaTable" v-loading="mediaTableLoading" size="mini" ref="mediaSelectTable">
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <span class="hide-label-radio">
                <el-radio v-model="selectMediaId" @change="onChangeMedia" :label="scope.row.mediaId"></el-radio>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="账号名称" prop="name" align="center" min-width="80"></el-table-column>
          <el-table-column label="平台" prop="mediaType" align="center" min-width="60">
            <template slot-scope="scope">
              {{ mediaConfig.getAppointed("media_ch", scope.row.mediaType, "") }}
            </template>
          </el-table-column>
          <el-table-column label="粉丝数" prop="fansNum" align="center" min-width="140"></el-table-column>
          <el-table-column label="账号ID/链接" prop="url" min-width="160"></el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination background @size-change="mediaSizeChange" @current-change="mediaCurrentChange" :current-page.sync="mediaPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="mediaPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="mediaPage.total">
          </el-pagination>
        </div>
      </div>
      <div class="submit-con">
        <el-button type="primary" size="small" @click="onConfirmMediaChoose">确认</el-button>
      </div>
    </el-dialog>
    <!-- 关联框架合同 -->
    <contractFramework ref="contractFramework" :contractValue="contractValue" @customChooseSave="customChooseSave" :contractDialog="contractDialog" @contractClose="contractClose"></contractFramework>
    <!-- 业务负责人 -->
    <el-dialog title="选择业务负责人" :visible.sync="adminListModal" width="1000px" class="yhg-dialog" @open="openAdminSelectModal">
      <div class="select-con single">
        <span class="label">已选人员：</span>
        <div class="content" v-if="selectAdmin">
          <el-tag v-if="selectAdmin.username" class="select-tag" closable :type="selectAdmin.username" effect="dark" @close="onAdminTagClose">
            <span class="select-tag-text">{{ selectAdmin.username }}</span>
          </el-tag>
        </div>
      </div>
      <div class="filter-con">
        <span class="label">用户搜索：</span>
        <el-input size="small" v-model="adminForm.queryString" placeholder="用户名/手机号" @keyup.enter.native="onAdminSearch"></el-input>
        <el-button class="search-btn" size="small" type="primary" @click="onAdminSearch">搜索</el-button>
      </div>
      <div class="table-con">
        <el-table :data="adminTable" v-loading="adminTableLoading" size="mini" ref="adminSelectTable">
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <span class="hide-label-radio">
                <el-radio v-model="selectAdminId" @change="onChangeAdmin" :label="scope.row.id"></el-radio>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="用户名" prop="username" align="center"></el-table-column>
          <el-table-column label="角色" prop="roleNameList" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.roleNameList">
                <div v-for="(item, index) in scope.row.roleNameList" :key="index">
                  {{ item }}
                </div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="phone" align="center">
            <template slot-scope="scope">
              {{ scope.row.phone ? scope.row.phone : "--" }}
            </template>
          </el-table-column>
          <el-table-column label="邮箱" prop="email">
            <template slot-scope="scope">
              {{ scope.row.email ? scope.row.email : "--" }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination background @size-change="adminSizeChange" @current-change="adminCurrentChange" :current-page.sync="adminPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="adminPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="adminPage.total">
          </el-pagination>
        </div>
      </div>
      <div class="submit-con">
        <el-button type="primary" size="small" @click="onConfirmAdminChoose">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import validate from "@/util/validate";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/contract";
import { listAdmin } from "@/api/business/contract";
import { deliveryConfig } from "@/const/config/delivery";
import { billingConfig,billingShow } from "@/const/config/billing";
import deliveryFormFields from "@/const/form/deliveryFormFields";
import {
  detailDelivery,
  listMedia,
  listMediaContract,
  addDelivery,
  editDelivery
} from "@/api/business/delivery";
import contractFramework from "@/components/common/contractFramework";
export default {
  components: {
    contractFramework
  },
  props: ["operateType"],
  data() {
    var validPrice = (rule, value, callback) => {
      if (!validate.checkNull(value)) {
        let err = validate.checkMoney(value, 100000000);
        if (err) {
          callback(new Error(err));
        }
        callback();
      }
      callback();
    };
    var validProject = (rule, value, callback) => {
      var index = rule.field.replace(/[^0-9]/gi, "");
      if (
        !validate.checkNull(
          this.bloggerForm.bloggerOtherCostList[index].costMoney
        ) &&
        validate.checkNull(value)
      ) {
        callback("请输入相应的成本金额明细");
      }
      callback();
    };
    var validCostMoney = (rule, value, callback) => {
      var index = rule.field.replace(/[^0-9]/gi, "");
      if (
        !validate.checkNull(
          this.bloggerForm.bloggerOtherCostList[index].project
        ) &&
        validate.checkNull(value)
      ) {
        callback("请输入相应的成本金额");
      }
      callback();
    };
    var validInvoiceMoney = (rule, value, callback) => {
      var index = rule.field.replace(/[^0-9]/gi, "");
      if (!validate.checkNull(value)) {
        callback();
        return;
      }
      if (
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceTitle
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceNum
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceTime
        ) ||
        (!validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceType
        ) &&
          validate.checkNull(value))
      ) {
        callback("请输入相应的发票金额");
      } else {
        callback();
      }
    };
    var validInvoiceTitle = (rule, value, callback) => {
      var index = rule.field.replace(/[^0-9]/gi, "");
      if (!validate.checkNull(value)) {
        callback();
        return;
      }
      if (
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceMoney
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceNum
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceTime
        ) ||
        (!validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceType
        ) &&
          validate.checkNull(value))
      ) {
        callback("请输入相应的发票抬头");
      }
      callback();
    };
    var validInvoiceNum = (rule, value, callback) => {
      var index = rule.field.replace(/[^0-9]/gi, "");
      if (!validate.checkNull(value)) {
        callback();
        return;
      }
      if (
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceTitle
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceMoney
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceTime
        ) ||
        (!validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceType
        ) &&
          validate.checkNull(value))
      ) {
        callback("请输入相应的发票号");
      }
      callback();
    };
    var validInvoiceTime = (rule, value, callback) => {
      var index = rule.field.replace(/[^0-9]/gi, "");
      if (!validate.checkNull(value)) {
        callback();
        return;
      }
      if (
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceTitle
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceNum
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceMoney
        ) ||
        (!validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceType
        ) &&
          validate.checkNull(value))
      ) {
        callback("请输入相应的发票时间");
      }
      callback();
    };
    var validInvoiceType = (rule, value, callback) => {
      var index = rule.field.replace(/[^0-9]/gi, "");
      if (!validate.checkNull(value)) {
        callback();
        return;
      }
      if (
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceTitle
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceNum
        ) ||
        !validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceTime
        ) ||
        (!validate.checkNull(
          this.invoiceForm.bloggerInvoiceList[index].invoiceMoney
        ) &&
          validate.checkNull(value))
      ) {
        callback("请选择相应的发票类型");
      }
      callback();
    };

    return {
       billingShow,
       billingConfig ,
      //博主其他成本
      bloggerForm: {
        bloggerOtherCostList: [
          {
            costMoney: "", //成本金额
            project: "", //项目
          },
        ],
      },
      bloggerRules: {
        costMoney: [
          { validator: validPrice, trigger: "blur" },
          { validator: validCostMoney, trigger: "blur" },
        ],
        project: [{ validator: validProject, trigger: "blur" }],
      },
      // //发票类型
      // options: [
      //   {
      //     value: 1,
      //     label: "增值税专用发票",
      //   },
      //   {
      //     value: 2,
      //     label: "增值税普通发票",
      //   },
      // ],
      //发票信息
      invoiceForm: {
        totalInvoiceMoney: null, //发票总金额
        bloggerInvoiceList: [
          {
            invoiceMoney: null, //发票金额
            invoiceTitle: "", //发票抬头
            invoiceNum: "", //发票号
            invoiceTime: "", //发票时间
            invoiceType: null, //发票类型
          },
        ],
      },
      invoiceRules: {
        invoiceMoney: [
          { validator: validPrice, trigger: "blur" },
          { validator: validInvoiceMoney, trigger: "blur" },
        ],
        invoiceTitle: [{ validator: validInvoiceTitle, trigger: "blur" }],
        invoiceNum: [{ validator: validInvoiceNum, trigger: "blur" }],
        invoiceTime: [{ validator: validInvoiceTime, trigger: "blur" }],
        invoiceType: [{ validator: validInvoiceType, trigger: "change" }],
      },
      mediaConfig: mediaConfig,
      deliveryConfig: deliveryConfig,

      form: {
        mediaType: null, //账号/博主平台
        mediaId: null, //账号/博主id
        bloggerName: null, //账号博主名称
        contractId: null, //关联合同
        recordPrincipal: "", //投放负责人
        reocrdPrincipalId: "", //投放负责人id
        contractName:"",
        customerName: "", //客户名称
        avatar: "", //客户头像
        brandName: "", //品牌名称
        productName: "", //产品名称
        publishType: "", //发布形式
        publishTime: "", //发布日期
        executePrice: "", //执行价格
        publishUrl: "", //投放链接
        settleStatus: 0, //结算状态
        settlePrice: "", //结算金额
        settleTime: "", //结算时间
        receiptPart: "", //收款方
        receiptTime: "", //收款时间
        shareIncome: "", //分成基数金额
        bloggerOtherCost: "", //博主其他成本
        finalRebate:"",//最终返点
        fixedRebate:"",//固定返点
        externalPlatform:"",//外部平台
        externalPlatformTaskId:"",//外部平台ID
        isRebateConfirmed:false,//返点是否已确认
        // receiveInvoiceFlag: "", //是否收到发票
        // invoiceTitle: "", //发票抬头
        // invoiceNum: "", //发票号
        // invoiceTime: "", //发票时间
        // invoiceType: "", //发票类型
        platfromCompanyId: "", //平台公司ID
        otherCost:0 ,
        wxjobPrice:0 ,
        presetRebatePrice:0 ,
        agentOrderPrice:0 ,
        otherPrice:0 ,
        travelPrice:0 ,



      },


      /**
       * 投放负责人模块
       */
      adminListModal: false,
      adminPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      adminForm: {
        queryString: "",
      },
      selectAdminId: null,
      selectAdmin: null,
      adminTable: [],
      adminTableLoading: false,

      rules: {
        mediaType: [
          { required: true, message: "请选择账号平台", trigger: "change" },
        ],
        bloggerName: [
          { required: true, message: "请选择博主名称", trigger: "change" },
        ],
        executePrice: [{ validator: validPrice, trigger: "change" },
                       { required: true, message: "请填写执行价", trigger: "change" }],
        finalRebate:[{ validator: validPrice, trigger: "change" }],
        settlePrice: [{ validator: validPrice, trigger: "change" }],
        shareIncome: [{ validator: validPrice, trigger: "change" }],
        otherCost: [{ validator: validPrice, trigger: "change" }],
        platfromCompanyId: [
          { required: true, message: "请选择平台公司", trigger: "change" },
        ],
        contractId: [
          { required: true, message: "请选择关联合同", trigger: "change" },
        ],
        recordPrincipal: [
          { required: true, message: "请选择投放负责人", trigger: "change" },
        ],
      },

      submitLoading: false,

      mediaListModal: false,
      mediaPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      mediaForm: {
        queryString: "",
      },
      selectMediaId: null,
      selectMedia: null,
      mediaTable: [],
      mediaTableLoading: false,

      relateContractList: [],
      contractDialog:false,
      contractValue:{} ,
      //平台公司
      platfromCompanyId:[{id:1,name:"薯一薯二文化传媒（上海）有限公司",isEnable: true},
      {id:2,name:"武汉巨量星图科技有限公司",isEnable: true},
      {id:3,name:"超电（上海）信息科技有限公司 ",isEnable: true},
      {id:4,name:"腾讯科技（深圳）有限公司",isEnable: true},
      {id:5,name:"宁波布谷鸟广告传媒有限公司",isEnable: true},
      {id:6,name:"天下秀广告有限公司",isEnable: true},
      {id:7,name:"广西耀远信息科技有限公司",isEnable: true},
      {id:8,name:"非商务运营平台开票合作",isEnable: true},
      {id:9,name:"天下秀科技有限公司",isEnable: true},
      {id:10,name:"武汉星图新视界科技有限公司",isEnable: true},
      {id:11,name:"薯鸿文化传媒（上海）有限公司",isEnable: true},
      ],
    };
  },
  created() {
    if (
      this.$route.query &&
      this.$route.query.id &&
      this.operateType !== "add"
    ) {
      this.getDetail(this.$route.query.id);
    }
  },
  mounted() {},
  methods: {
    //关联合同确认
    customChooseSave(val){
      if(val){
        this.form.contractId = val.id
        this.form.contractName = val.name;
        this.form.customerName = val.customerName;
        this.form.brandName = val.brandName;
        this.form.productName = val.productName;
      }else{
        this.form.contractId = ""
        this.form.contractName = ""
        this.form.customerName =""
        this.form.brandName = ""
        this.form.productName = ""
      }
      
      this.contractDialog = false;
    },
    rebatesInput(){
      if(this.form.finalRebate<=0){
        this.form.finalRebate = ""
      }
    },
    //关联合同
    contractClick(){
      this.contractValue = {
        id:this.form.contractId,
        name:this.form.contractName
      }
      this.$refs.contractFramework.customForm.mediaType = this.form.mediaType;
      this.$refs.contractFramework.customForm.mediaId = this.form.mediaId;
      this.contractDialog = true;
    },
    contractClose(){
      this.contractDialog = false;
    },
    /**
     * 新增商务信息
     */
    addBlogger() {
      this.bloggerForm.bloggerOtherCostList.push({
        costMoney: "",
        project: "",
      });
    },
    /**
     * 删除商务信息
     * @param index 索引
     */
    removeBlogger(index) {
      this.bloggerForm.bloggerOtherCostList.splice(index, 1);
    },
    /**
     * 新增发票信息
     */
    addInvoice() {
      this.invoiceForm.bloggerInvoiceList.push({
        invoiceMoney: null,
        invoiceTitle: "",
        invoiceNum: "",
        invoiceTime: "",
        invoiceType: null,
      });
    },
    /**
     * 删除发票信息
     * @param index 索引
     */
    removeInvoice(index) {
      this.invoiceForm.bloggerInvoiceList.splice(index, 1);
    },
    //打开资源选择弹窗
    onOpenMediaSelectModal() {
      if (!this.form.mediaType) {
        this.$message.warning("请选择账号平台");
        return;
      }
      this.mediaListModal = true;
    },
    //资源选择弹窗打开
    openMediaSelectModal() {
      if (this.form.mediaId) {
        this.selectMedia = {
          mediaId: this.form.mediaId,
          name: this.form.bloggerName,
        };
        this.selectMediaId = this.selectMedia.mediaId;
      } else {
        this.selectMedia = null;
        this.selectMediaId = null;
      }
      this.mediaForm.queryString = "";
      this.onMediaSearch();
    },
    //资源平台切换
    onChangeMediaType(val) {
      this.form.bloggerName = null;
      this.form.mediaId = null;
      this.form.contractId = null;
      this.form.customerName = "";
      this.form.brandName = "";
    },
    //资源选择变化
    onChangeMedia(val) {
      this.selectMedia = this.mediaTable.find((v) => v.mediaId == val);
    },
    //资源标签删除
    onMediaTagClose() {
      this.selectMedia = null;
      this.selectMediaId = null;
    },
    //资源弹窗关闭
    onConfirmMediaChoose() {
      if (this.selectMedia) {
        this.form.bloggerName = this.selectMedia.name;
        this.form.mediaId = this.selectMedia.mediaId;
        this.form.avatar = this.selectMedia.avatar;
        this.getMediaContract();
      } else {
        this.form.bloggerName = "";
        this.form.avatar = "";
        this.form.mediaId = null;
        this.getMediaContract(true);
      }
      this.mediaListModal = false;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    mediaSizeChange(val) {
      this.mediaPage.pageNum = 1;
      this.mediaPage.pageSize = val;
      this.getMediaList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    mediaCurrentChange(val) {
      this.mediaPage.pageNum = val;
      this.getMediaList();
    },
    //资源搜索
    onMediaSearch() {
      this.mediaPage.pageNum = 1;
      this.getMediaList();
    },
    //获取资源列表
    getMediaList() {
      let obj = {
        pageSize: this.mediaPage.pageSize,
        pageNum: this.mediaPage.pageNum,
      };
      obj.mediaType = this.form.mediaType;
      if (this.mediaForm.queryString && this.mediaForm.queryString.trim()) {
        obj.queryString = this.mediaForm.queryString.trim();
      }
      this.mediaTableLoading = true;
      listMedia(obj)
        .then((res) => {
          this.mediaTable = res.data || [];
          this.mediaPage.total = res.total;
          this.mediaTableLoading = false;
        })
        .catch((err) => {
          this.mediaTable = [];
          this.mediaPage.total = 0;
          this.mediaTableLoading = false;
        });
    },
    //获取博主关联合同
    getMediaContract(clear) {
      if (clear) {
        this.relateContractList = [];
      } else {
        if (!this.form.mediaType || !this.form.mediaId) return;
        listMediaContract({
          mediaType: this.form.mediaType,
          mediaId: this.form.mediaId,
        })
          .then((res) => {
            console.log(res.data);
            // if (res.data.length == 0) {
            //   this.$message.warning("该博主未关联任何进行中的合同");
            // }
            res.data.forEach((r) => {
              r.disabled =
                r.status === 3 || r.status === 5 || r.status === 8
                  ? false
                  : true;
            });
            this.relateContractList = res.data;
          })
          .catch((err) => {
            this.relateContractList = [];
          });
      }
    },
    //合同选择--模拟
    selectContract(val) {
      let o = this.relateContractList.find((v) => v.id == val);
      console.log(o);
      if (o) {
        this.form.customerName = o.customerName;
        this.form.brandName = o.brandName;
        this.form.productName = o.productName;
      } else {
        this.form.customerName = "";
        this.form.brandName = "";
        this.form.productName = "";
      }
    },
    //获取投放详情
    getDetail(id) {
      detailDelivery({ id }).then((res) => {
        if (res.data) {
          console.log("进页面获取数据==========", res.data);
          this.invoiceForm.bloggerInvoiceList = res.data.bloggerInvoiceList;
          if (res.data.bloggerOtherCostList.length > 0) {
            this.bloggerForm.bloggerOtherCostList =
              res.data.bloggerOtherCostList;
          }
          if (res.data.totalInvoiceMoney) {
            this.invoiceForm.totalInvoiceMoney = res.data.totalInvoiceMoney;
          }
          this.form = res.data;
          this.getMediaContract();
          this.$nextTick(() => {
            this.$refs.deliveryForm.clearValidate();
          });
        }
      });
    },

    //判断其他成本
    checkBlogger() {
      if(this.bloggerForm.bloggerOtherCostList){
        // if (this.bloggerForm.bloggerOtherCostList.length > 1) {
        this.bloggerForm.bloggerOtherCostList.forEach((r, i) => {
          if (!r.costMoney || !r.project) {
            delete this.bloggerForm.bloggerOtherCostList[i];
          }
        });
        // }
        this.bloggerForm.bloggerOtherCostList = this.bloggerForm.bloggerOtherCostList.filter(
          (n) => n
        );
        if (this.bloggerForm.bloggerOtherCostList.length == 0) {
          this.bloggerForm.bloggerOtherCostList = null;
        }
      }
    },
    //判断博主发票
    checkInvoice() {
      if(this.invoiceForm.bloggerInvoiceList){
        // if (this.invoiceForm.bloggerInvoiceList.length > 1) {
        this.invoiceForm.bloggerInvoiceList.forEach((r, i) => {
          if (
            !r.invoiceMoney ||
            !r.invoiceTitle ||
            !r.invoiceNum ||
            !r.invoiceTime ||
            !r.invoiceType
          ) {
            delete this.invoiceForm.bloggerInvoiceList[i];
          }
        });
        // }
        this.invoiceForm.bloggerInvoiceList = this.invoiceForm.bloggerInvoiceList.filter(
          (n) => n
        );
        if (this.invoiceForm.bloggerInvoiceList.length == 0) {
          this.invoiceForm.bloggerInvoiceList = null;
        }
      }
    },
    //提交
    onSubmit() {
      let errorList = [];
      // 验证表单;
      this.$refs.deliveryForm.validate((valid, obj) => {
        if (valid) {
          //验证博主金额
          this.$refs.bloggerForm.validate((valid, obj) => {
            if (valid) {
              //验证发票信息
              this.$refs.invoiceForm.validate((valid, obj) => {
                if (valid) {
                  this.checkBlogger();
                  this.checkInvoice();
                  this.toSubmit();
                } else {
                  for (var i in obj) {
                    let msg = i.slice(22);
                    errorList.push(deliveryFormFields.list[msg]);
                  }
                  this.$message.error(
                    "表单不完整！请检查" +
                      "“" +
                      errorList.join("、") +
                      "”" +
                      "是否按要求填写"
                  );
                }
              });
            } else {
              for (var i in obj) {
                let msg = i.slice(24);
                errorList.push(deliveryFormFields.list[msg]);
              }
              this.$message.error(
                "表单不完整！请检查" +
                  "“" +
                  errorList.join("、") +
                  "”" +
                  "是否按要求填写"
              );
            }
          });
        } else {
          this.$message.error(
            "表单不完整！请检查" +
              Object.keys(obj)
                .map((v) => "“" + deliveryFormFields.list[v] + "”")
                .join("、") +
              "是否按要求填写"
          );
        }
        console.log(errorList);
      });
    },
    //数据赋值
    toSubmit() {
      this.form.bloggerInvoiceList = this.invoiceForm.bloggerInvoiceList;
      this.form.bloggerOtherCostList = this.bloggerForm.bloggerOtherCostList;
      this.form.totalInvoiceMoney = this.invoiceForm.totalInvoiceMoney;
      switch (this.operateType) {
        case "add":
          this.deliveryAdd(this.form);
          break;
        case "edit":
          this.deliveryEdit(this.form);
          break;
        default:
          break;
      }
    },
    //新增
    deliveryAdd(form) {
      this.submitLoading = true;
      addDelivery(form)
        .then((res) => {
          this.submitLoading = false;
          this.$message.success("新增投放成功");
          this.$emit("toDeliveryList");
        })
        .catch((err) => {
          this.submitLoading = false;
        });
    },
    //新增
    deliveryEdit(form) {
      this.submitLoading = true;
      editDelivery(form)
        .then((res) => {
          this.submitLoading = false;
          this.$message.success("修改投放成功");
          this.$router.push({
            path: "/business/delivery-log",
          });
        })
        .catch((err) => {
          this.submitLoading = false;
        });
    },

    /**
     * 业务负责人模块
     */
    //打开资源选择弹窗
    onOpenAdminSelectModal() {
      this.adminListModal = true;
    },
    //资源选择弹窗打开
    openAdminSelectModal() {
      this.adminListModal = true;
      this.onAdminSearch();
    },
    //资源标签删除
    onAdminTagClose() {
      this.selectAdmin = null;
      this.selectAdminId = null;
    },
    //资源弹窗关闭
    onConfirmAdminChoose() {
      if (this.selectAdmin) {
        this.form.recordPrincipalId = this.selectAdmin.id;
        this.form.recordPrincipal = this.selectAdmin.username;
      } else {
        this.form.recordPrincipal = "";
        this.form.recordPrincipalId = null;
      }
      this.adminListModal = false;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    adminSizeChange(val) {
      this.adminPage.pageNum = 1;
      this.adminPage.pageSize = val;
      this.getAdminList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    adminCurrentChange(val) {
      this.adminPage.pageNum = val;
      this.getAdminList();
    },
    //资源搜索
    onAdminSearch() {
      this.adminPage.pageNum = 1;
      this.getAdminList();
    },
    //获取资源列表
    getAdminList() {
      let obj = {
        pageSize: this.adminPage.pageSize,
        pageNum: this.adminPage.pageNum,
        usernameOrPhone:this.adminForm.queryString
      };
      this.adminTableLoading = true;
      listAdmin(obj)
        .then((res) => {
          this.adminTable = res.data || [];
          this.adminPage.total = res.total;
          this.adminTableLoading = false;
        })
        .catch((err) => {
          this.adminTable = [];
          this.adminPage.total = 0;
          this.adminTableLoading = false;
        });
    },
    //资源选择变化
    onChangeAdmin(val) {
      console.log('====val====',val)
      this.selectAdmin = this.adminTable.find((v) => v.id == val);
    },

  },
  watch: {
    operateType(newVal, oldVal) {},
    invoiceForm: {
      handler(newValue, oldValue) {
        let arrPrice = 0;
        if(newValue.bloggerInvoiceList){
          newValue.bloggerInvoiceList.forEach((r) => {
            let price = parseFloat(r.invoiceMoney);
            if (price) {
              arrPrice = arrPrice + price;
            } else {
              arrPrice = arrPrice + 0;
            }
          });
           this.invoiceForm.totalInvoiceMoney = arrPrice.toFixed(2);
        }
      },
      deep: true,
    },
    bloggerForm: {
      handler(newValue, oldValue) {
        let arrPrice = 0;
        if(newValue.bloggerOtherCostList){
          newValue.bloggerOtherCostList.forEach((r) => {
            let price = parseFloat(r.costMoney);
            if (price) {
              arrPrice = arrPrice + price;
            } else {
              arrPrice = arrPrice + 0;
            }
            this.form.bloggerOtherCost = arrPrice.toFixed(2);
          });
        }
      },
      deep: true,
    },

    form: {
      handler(newValue, oldValue) {

        this.form.otherCost = parseFloat(this.form.wxjobPrice)  + parseFloat(this.form.presetRebatePrice) 
                              + parseFloat(this.form.agentOrderPrice) 
                              + parseFloat(this.form.otherPrice) + parseFloat(this.form.travelPrice) ;
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.form-block {
  position: relative;
  padding-bottom: 20px;

  .bottom-divider {
    position: absolute;
    left: -15px;
    right: -15px;
    bottom: 0;
    height: 10px;
    background: #f0f2f5;
    box-shadow: 0 2px 12px 0 rgb(220, 222, 226) inset;
  }

  .title {
    margin: 5px 0;
    font-size: 14px;
  }
  .divider {
    margin: 8px 0 10px;
  }

  &-submit {
    padding-top: 15px;
    text-align: center;
  }

  .block-form-item {
    &.w-25 {
      display: inline-block;
      width: 24%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-50 {
      display: inline-block;
      width: 49%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-99 {
      width: 99%;
      margin-right: 1%;
    }
  }
}

.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &.single {
      align-items: center;
      .select-tag {
        margin-bottom: 0;
      }
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
/deep/.select-con {
  .el-tag .el-icon-close {
    top: -2px;
  }
}
</style>

<style lang="scss">
.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 32px;
    height: 32px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      left: -1px;
      font-size: 33px !important;
    }
    cursor: pointer;
  }
}
.avue-view .cost-table {
  width: calc(50% + 100px);
  th {
    background: none;
    font-weight: normal;
    font-size: 14px;
  }
  .cell {
    padding-left: 0;
  }
}
.el-table .operate-column {
  vertical-align: text-top;
}
</style>
